"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChainflexImportWithSeries = exports.ChainflexImportWithSeriesSchema = void 0;
const ChainflexImport_1 = require("./ChainflexImport");
const ChainflexSerieImport_1 = require("./ChainflexSerieImport");
exports.ChainflexImportWithSeriesSchema = ChainflexImport_1.ChainflexImportSchema.extend({
    serie: ChainflexSerieImport_1.ChainflexSerieImportSchema,
});
const isChainflexImportWithSeries = (whatever) => {
    var _a;
    return (_a = exports.ChainflexImportWithSeriesSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isChainflexImportWithSeries = isChainflexImportWithSeries;
//# sourceMappingURL=ChainflexImportWithSeries.js.map